import * as React from 'react'
import { ICustomerMarkup } from './interfaces'

export const defaultMarkup: ICustomerMarkup = {
    introduction: {
        intro1: <div>
            <p className="lead">A retirement planning calculator is a tool that can help you plan your retirement.
            To get a reasonable picture of what your retirement could look like, you will need to enter information for the
            various sections including...</p>
            <ol className="lead">
                <li>Pension benefits</li>
                <li>Social Security benefits</li>
                <li>401(k), 403(b), 457 plans and IRA accounts</li>
                <li>Personal expenses</li>
            </ol>
        </div>,
        intro2: <div>
            <br />
            <br />
            <p className="lead">Keep in mind that these are reasonable estimates of your benefit picture.
            To get actual benefit amounts, you will need to talk to the administrators of each of the benefits involved.</p>
            <br />
        </div>
    },
    pension: {
        introduction: {
            intro1: <div>
                <h5 className="lead">
                    In this section, you'll work through the pension benefits that you have
                    earned during your career. Each benefit is shown as an annuity under the
                    various optional forms of payment provided from the plan.  You will need
                    to select your point of retirement and form of payment for each plan shown.
                </h5>
            </div>
        },
        summary: {
            underTable: <div></div>
        }
    },
    retirement: {
        introduction: {
            intro1: <div>
                <h5 className="lead">In this section, you'll need to enter the most recent
                account balance for your Savings Plan and any other savings (prior balances in 401(k), 403(b) or 457 plans; IRA balances; personal savings) that you and your spouse have.
                </h5>
                <p>You will then be able to incorporate estimated contributions, investment returns, and withdrawal amounts to project how long your savings can last during retirement.  Keep in mind that this is a simple projection that models future scenarios based on the assumptions you select.  Actual results will vary based on actual experience.  For a more sophisticated look at your future savings balances, you may want to contact an investment professional.</p>
                <br/><br/>
            </div>
        },
        summary: {
          underTable: <div></div>
        }
    }
}



// WEBPACK FOOTER //
// ./src/config/defaultMarkup.tsx